import Link from "next/link";
import type { ReactNode } from "react";

type Variant = "or" | "ghost";

const styles: Record<Variant, string> = {
  or: "bg-or text-[#171105] hover:bg-[#e7b657]",
  ghost: "border border-corail/35 text-corail hover:border-or hover:text-or",
};

const base =
  "active:scale-[0.98] inline-flex min-h-11 items-center justify-center rounded-full px-7 py-3 text-[13.5px] font-semibold tracking-wide transition-colors";

/** Classes des boutons, réutilisables par les variantes client (EnterExperienceLink) */
export function buttonClasses(variant: Variant = "or"): string {
  return `${base} ${styles[variant]}`;
}

export function ButtonLink({
  href,
  variant = "or",
  children,
  external = false,
}: {
  href: string;
  variant?: Variant;
  children: ReactNode;
  external?: boolean;
}) {
  const cls = `${base} ${styles[variant]}`;
  if (external) {
    return (
      <a href={href} className={cls}>
        {children}
      </a>
    );
  }
  return (
    <Link href={href} className={cls}>
      {children}
    </Link>
  );
}

export function Button({
  variant = "or",
  children,
  ...props
}: {
  variant?: Variant;
  children: ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={`${base} ${styles[variant]}`} {...props}>
      {children}
    </button>
  );
}
